/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react'
import { IcoMoon, KeyboardArrowDownIcon, KeyboardArrowUpIcon } from '@usap/uicomponents'
import { StyledContent, StyledTitle, StyledTitleButton } from './Accordion.css'

type AccordionItemProps = {
  title: string;
  content: string;
};

const AccordionItem = ({ title, content }: AccordionItemProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div>
      <StyledTitleButton onClick={() => setIsOpen(!isOpen)}>
        <StyledTitle>{title}</StyledTitle>
        <IcoMoon color="#3E3E47" icon={isOpen ? KeyboardArrowUpIcon : KeyboardArrowDownIcon} size="medium" />
      </StyledTitleButton>
      {isOpen && <StyledContent>{content}</StyledContent>}
    </div>
  )
}

type AccordionProps = {
  items: AccordionItemProps[];
};

const Accordion = ({ items }: AccordionProps) => (
  <div>
    {items.map((item, index) => (
      <AccordionItem key={`${item.title}${index}`} title={item.title} content={item.content} />
    ))}
  </div>
)

export default Accordion
